import React from "react";
import PlantForm from "../../forms/plant/PlantForm";
import EditPlantContainer from "../../containers/plants/EditPlantContainer";
import Modal from "../../components/Modal";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTranslation } from "react-i18next";

const Edit = ({ handleClose, open, plant }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const { t } = useTranslation();

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("details_modal.edit_plant")}
    >
      {plant ? (
        <EditPlantContainer plant={plant}>
          {({ onSubmit, plant }) => (
            <PlantForm onSubmit={onSubmit} initialValues={plant} />
          )}
        </EditPlantContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
